import { User } from '../../../types/user';
import { useUserStats } from '../hooks';

interface StatsCardsProps {
  user: User;
}

/**
 * StatsCards - Cards de estatísticas rápidas
 *
 * Exibe 3 cards com informações resumidas: Conversas, Projetos, Último Acesso
 * Migrado para Tailwind CSS v4
 */
export const StatsCards = ({ user }: StatsCardsProps) => {
  // Fetch real stats from API
  const { stats: userStats } = useUserStats();

  const stats = [
    { label: 'Conversas', value: String(userStats?.conversations || 0), icon: '💬' },
    { label: 'Projetos', value: String(userStats?.projects || 0), icon: '📁' },
    {
      label: 'Último Acesso',
      value: user.last_login
        ? new Date(user.last_login).toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
          })
        : '--/--',
      icon: '🕐',
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-4 mb-6">
      {stats.map((stat, index) => (
        <div
          key={stat.label}
          className="bg-[#2a2a2a] rounded-xl p-4 border border-[#333333] hover:border-[#F4CC04] transition-all duration-400 animate-fadeInUp"
          style={{ animationDelay: `${index * 100}ms` }}
        >
          <div className="flex flex-col items-center text-center gap-2">
            <span className="text-2xl m-0">{stat.icon}</span>
            <span className="text-2xl md:text-3xl font-bold text-white tabular-nums m-0">
              {stat.value}
            </span>
            <span className="text-xs text-[#CCCCCC] m-0">{stat.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
